export default function genererCritereRechercheCollectivite() {
  return {
    auto: null,
    villes: [],
    agencesId: [],
    adresse: null,
    depts: [],
    nomCommercial: null,
    compteComptable: null,
    telephone: null,
    email: null,
    archive: false,
    tiers: [],
  };
}
